import React from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';

import styled from 'styled-components'
import { connect } from 'react-redux';
import { userActions } from '../../_actions';
import { history } from '../../_helpers';

const OverlayDiv = styled.div`
  position: fixed;
  left: 300px;
  top: 0px;
  height: 100vh;
  width: calc(100vw - 300px);
  /* background-color: rgba(144, 45, 19, .3); */
  background-color:   rgba(19, 142, 243, .3);

  z-index: 2;


  transition: .2s ease-out;
`


class Confirm extends React.Component{
//   _onReady(event) {
    // access to player in all event handlers via event.target
    // event.target.pauseVideo();
//   }

    constructor(props){
        super(props)
        this.state = {
            email:'',
            password:'',
            letitgo: false,

        };
    }
    componentDidMount(){
        console.log('Did mount')
        console.log(this.props.location.pathname)

        console.log(localStorage)

        let link = this.props.location.pathname
        let email = link.split('/')[3]
        let token = link.split('/')[4]
        console.log(email, token)

        let headers = new Headers();
        // let base_link =  "http://localhost:8000"
        let base_link =  "https://qurator.co.kr"
        let url_test = 'http://localhost:8000/user/confirm/' + '?email=' + email + '&token=' + token
        let url = 'https://qurator.co.kr/user/confirm/' + '?email=' + email + '&token=' + token

        // let user = JSON.parse(localStorage.getItem('user'));
        

        

        // this.props.tokenLogin(token, '');
        console.log(email)
        
        

        console.log(localStorage)

        fetch(url, {
            method:'GET',
            // headers: headers
            //credentials: 'user:passwd'
            })
            .then(response => {
                if(response.status===200){
                    localStorage.setItem('email', email)
                    localStorage.setItem('user', JSON.stringify({"token": token}))   
                }
                else{
                  
                }
            }
            )
            .then(json => {
              
              console.log(json)
              fetch(base_link + "/user/whoru/", {
                method: 'POST',
                headers: {Authorization: `JWT ${token}`},
                body: JSON.stringify({
                  "is_candidate": true
                })
              })
              .then(response => response.json())
              .then(json=>{
                fetch (base_link + '/user/alldata/' , {
                  method: 'GET',
                  headers: {Authorization: `JWT ${token}`},
                })
                .then(
                  response=>response.json()
                )
                .then(json=>{
                  localStorage.setItem('is_headhunter', json["is_headhunter"])
                  localStorage.setItem('is_recruiter', json["is_recruiter"])
                  
                  
                  if(json["school#"] === 0 && json["work#"] === 0 && json["resume#"] === 0 ){
                      history.push('/signIn');
                  }
                  else{
                      history.push('/profile');
                  }
                  
                })
              })


                
            })


        
        // const { email, password } = this.state;
        // if (email && password) {
        // this.props.login(email, password);
        // }




    }

  render(){
      console.log(this.props)
      console.log(localStorage.email)
    //   console.log(this.props.location.pathname)
    if (localStorage.email === undefined){
        console.log("UNDEFINED")
    }
      return(
          <div >
            <div style={{color: 'white'}}>
              CONFIRM
            </div>
            {/* {   this.state.letitgo &&
                <Redirect to='/'/>} */}
          </div>
      )
    //   return <div>{this.props.logged_in ? this.logged_in_nav() : this.logged_out_nav}</div>;  
  }
  
}
function mapState(state) {
    const { loggingIn } = state.authentication;
    return { loggingIn };
}

const actionCreators = {
    login: userActions.login,
    tokenLogin: userActions.tokenLogin
};

const connectedLoginPage = connect(mapState, actionCreators)(Confirm);
export { connectedLoginPage as Confirm };

// Nav.propTypes = {
//   logged_in: PropTypes.bool.isRequired,
//   display_form: PropTypes.func.isRequired,
//   handle_logout: PropTypes.func.isRequired
// };